import type { ChannelEventBus } from '../../../../../emitter';
import { toOztMethod } from '../../../../components/InterfaceAppIntegrations/component/utils/ozonetel/toMethod';
import { toPusherMethod } from '../../../../components/InterfaceAppIntegrations/component/utils/pusher/toMethod';
import type { InterfaceEventBusType } from '../../../../types/eventBus';
import { getPageEventGroupId, PAGE_EVENT_GROUP_ID } from '../../../../utils/getPageEventGroupId';
import type { PageEvent } from './types';

interface HandleIntegrationPageEventParams {
  event: PageEvent;
  interfaceEventBus: ChannelEventBus<InterfaceEventBusType>;
}

export function handleIntegrationPageEvent({
  event,
  interfaceEventBus,
}: HandleIntegrationPageEventParams) {
  switch (getPageEventGroupId(event.eventType)) {
    case PAGE_EVENT_GROUP_ID.OZONETEL: {
      const oztMethod = toOztMethod(event.eventType, event.eventPayload);
      if (oztMethod) {
        interfaceEventBus.publish('onOztMethod', oztMethod);
      } else {
        console.error(`Invalid Ozonetel method payload for ${event.eventType}`, event.eventPayload);
      }
      return;
    }
    case PAGE_EVENT_GROUP_ID.PUSHER: {
      const pusherMethod = toPusherMethod(event.eventType, event.eventPayload);
      if (pusherMethod) {
        interfaceEventBus.publish('onPusherMethod', pusherMethod);
      } else {
        console.error(`Invalid Pusher method payload for ${event.eventType}`, event.eventPayload);
      }
      return;
    }
    default:
      return;
  }
}
